import module from './module.js'
// Components
import './components/component.js'
import './components/generar/component.js'
import './components/launcher/component.js'
// Services
import './services/Reporteisn.js'
import './services/ReporteisnOpciones.js'
// Routes
import './routes/contabilidad-isn.js'

export default module.name



// WEBPACK FOOTER //
// ./src/contabilidad/reporteisn/index.js